import { Injectable } from '@angular/core';
import { Ticket, TicketGetResponse } from 'src/app/shared/models/tickets/ticket.model';
import { TICKET_FROM_CLIENT_STATUS_DICTIONARY, INCIDENT_TYPE_ALL_TICKETS_DICTIONARY, STATUS_NOTARIZA_DICTIONARY } from 'src/app/shared/constants/crece-digital.constants';

@Injectable({
  providedIn: 'root',
})
export class TicketFromClientDetailMapperService {

  toTicketDetail(ticket: TicketGetResponse): Ticket {
    const rawIncidentType = (ticket.tipoIncidencia ?? [])[0] || '';
    const rawStatusConstitution = ticket.metadata?.['estado_constitucion_creacion'];

    return {
      idTicket: ticket.idTicket == null ? '' : String(ticket.idTicket),
      recordIdTicket: ticket.recordIdTicket || '',
      phone: ticket.celular || '',
      lastStateUpdateDate: ticket.fechaUltimaModificacionEstadoTicket
        ? new Date(ticket.fechaUltimaModificacionEstadoTicket)
        : undefined,
      registerDate: ticket.fechaRegistro ? new Date(ticket.fechaRegistro) : undefined,
      clientName: ticket.nombresApellidos || '',
      responseUser: ticket.responseUser ?? undefined,
      statusTicket: TICKET_FROM_CLIENT_STATUS_DICTIONARY[ticket.status] ?? ticket.status ?? '',
      incidentType: rawIncidentType
        ? (INCIDENT_TYPE_ALL_TICKETS_DICTIONARY[rawIncidentType] ?? rawIncidentType)
        : '',
      incidence: ticket.descripcion || '',
      attachedDocument: (ticket.documentoAdjunto ?? []).map(doc => ({
        nombre: doc.nombre, url: doc.url, id: doc.id, domainType: doc.domainType,
      })),
      clientAttachedDocument: (ticket.clientAttachedDocument ?? []).map(doc => ({
        nombre: doc.nombre, url: doc.url, id: doc.id, domainType: doc.domainType,
      })),
      reservedName: ticket.nombreReservado ?? undefined,
      recordIdConstitution: ticket.recordIdConstitution,
      creceID: ticket.creceId || '',
      reporter: ticket.creadoPor ?? undefined,
      solutionIncidence: undefined,
      statusConstitution: rawStatusConstitution
        ? (STATUS_NOTARIZA_DICTIONARY[rawStatusConstitution] ?? rawStatusConstitution)
        : undefined,
      assignedAdvisor: undefined,
      priority: undefined,
    };
  }
}
